import { Paper, Typography, Chip, Grid, Stack, Divider, Box, TextField, IconButton, Tooltip, Select, MenuItem, Button } from "@mui/material";
import { Add as AddIcon, Remove as RemoveIcon, PersonAdd as PersonAddIcon, Info as InfoIcon, PointOfSale as PosIcon } from "@mui/icons-material";
import { ShoppingCartCheckout as CheckoutIcon, } from "@mui/icons-material";

const currencyRD = (v) =>
  new Intl.NumberFormat("es-DO", { style: "currency", currency: "DOP" }).format(v);

const INVOICE_TYPES = [
    { id: "cf01", name: "Crédito fiscal (01)" }
  ];
  
export default function InvoicePanel({
    items,
    onIncrease,
    onDecrease,
    onRemove,
    totals,
    priceList,
    setPriceList,
    invoiceType,
    setInvoiceType,
    client,
    onNewClient,
    shiftOpen,
    onPaymentMethod,
    prestamo,
    prestamoDetalle,
    selectedCuotas,
    pagoTipo,
    setPagoTipo,
    gestionCargosPagados
  }) {
    return (
      <Paper
        elevation={1}
        sx={{
          backgroundColor:"white",
          borderRadius: 2,
          p: 2,
          top: 16,
          width: "100%",
          height: "calc(80vh - 32px)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
          <Typography variant="h6" fontWeight={700}>
            Pago de cargos
          </Typography>
  
          <Chip
            size="small"
            icon={<PosIcon />}
            color={shiftOpen ? "success" : "default"}
            label={`Caja: ${shiftOpen ? "Disponible" : "Cerrada"}`}
            variant={shiftOpen ? "filled" : "outlined"}
          />
        </Stack>
  
        <Grid container spacing={1} mb={1} >  
          <Grid item size={6} textAlign={"left"}  mx={2}>
              <Typography fontWeight={600}>Numeracion</Typography>
              <Select
                sx={{backgroundColor:"white"}}
                value={invoiceType}
                onChange={(e) => setInvoiceType(e.target.value)}
              >
                {INVOICE_TYPES.map((t) => (
                  <MenuItem key={t.id} value={t.id}>
                    {t.name}
                  </MenuItem>
                ))}
              </Select>
          </Grid>
          <Grid item size={6} textAlign={"left"}  mx={2}>
          <Typography fontWeight={600} textAlign={"left"} sx={{marginTop:2}}>Cliente</Typography>            
            <TextField
              size="small"
              fullWidth
              disabled
              value={prestamo?.cliente_nombre || ""}
              InputProps={{ readOnly: true }}
            />

          </Grid>
        </Grid>
  
  
        <Divider sx={{ my: 1 }} />
  
        <Box sx={{ flex: 1, overflowY: "auto", pr: 1 }}>
          {items.length === 0 ? (
            <Stack height="100%" alignItems="center" justifyContent="center" spacing={1} color="text.secondary">
              <InfoIcon />
              <Typography variant="body2">Agrega cargos desde el catálogo.</Typography>
            </Stack>
          ) : (
            items.map((row) => (
              <Box key={row.id}>
                <Grid container alignItems="center" spacing={1} sx={{ py: 1 , backgroundColor:"white" }}>
                  <Grid item size={5} textAlign={"left"}>
                    <Typography variant="subtitle2" fontWeight={600}>
                      {row.name}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {currencyRD(row.price)} c/u
                    </Typography>
                  </Grid>
                  <Grid item size={3}>
                    <Stack direction="row" alignItems="center" spacing={1} justifyContent="center">
                      <IconButton size="small" onClick={() => onDecrease(row.id)} disabled={row.qty <= 1}>
                        <RemoveIcon fontSize="small" />
                      </IconButton>
                      <Typography width={28} textAlign="center">
                        {row.qty}
                      </Typography>
                      <IconButton size="small" onClick={() => onIncrease(row.id)}>
                        <AddIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                  </Grid>
                  <Grid item size={3}>
                    <Stack alignItems="flex-end">
                      <Typography variant="subtitle2" sx={{marginTop:1,fontWeight:"bold"}}>{currencyRD(row.total)}</Typography>
                      <Typography size="small" color="error" onClick={() => onRemove(row.id)} sx={{marginTop:-1}} >
                        Quitar
                      </Typography>
                    </Stack>
                  </Grid>
                </Grid>
                <Divider />
              </Box>
            ))
          )}
        </Box>
  
        <Box sx={{ pt: 1 }}>
          <Stack direction="row" justifyContent="space-between" mb={0.5}>
            <Typography color="text.secondary">Subtotal</Typography>
            <Typography color="text.secondary">{currencyRD(totals.subtotal)}</Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between" mb={1}>
            <Typography color="text.secondary">Impuestos</Typography>
            <Typography color="text.secondary">{currencyRD(totals.taxes)}</Typography>
          </Stack>
  
          <Button
            variant="contained"
            fullWidth
            size="large"
            color="primarybutton"
            startIcon={<CheckoutIcon />}
            sx={{ borderRadius: 1 , fontWeight:"bold"}}
            disabled={items.length === 0 || !shiftOpen}
            onClick={onPaymentMethod}
          >
            Pagar · {currencyRD(totals.total)}
          </Button>
  
          <Stack direction="row" justifyContent="space-between" mt={0.5}>
            <Typography variant="caption">{items.length} {items.length === 1 ? "Producto" : "Productos"}</Typography>
            <Button size="small" onClick={() => window.location.reload()}>Cancelar</Button>
          </Stack>
        </Box>
      </Paper>
    );
  }
  